import React from "react";
import type { UseQueryResult } from "@tanstack/react-query";
import type { SEmbedSessionResponse } from "@norma-bi/bi-api";

type FullAppSessionContext = {
  embedSession: UseQueryResult<SEmbedSessionResponse>;
  isSwitching: boolean;
  switchError: Error | null;
  switchBusiness: (id: string) => Promise<void>;
  canPostToken: () => boolean;
};

export const sFullAppContext = React.createContext<FullAppSessionContext | null>(null);

export function useSFullAppSession() {
  const value = React.useContext(sFullAppContext);
  if (!value) throw new Error("SFullAppProvider is required");
  return value;
}
